import React, {useContext} from 'react'
import {useLocation, Link, withRouter} from 'react-router-dom'
import AltHeader from './altHeader'
import HomeHeader from './homeHeader'
import {ContextApp} from '../context/ContextApp'

const Header = ({history}) => {
  const contextApp = useContext(ContextApp)
  const {user, signOut} = contextApp
  const useHistoryHook = useLocation()

  const cleanSession = () => {
    signOut()
    history.push('/')
  }

  const location = useLocation()


  return (
    <div>
      <div
        className="top-bar hidden-ms-down"
        style={{
          backgroundColor: 'white',
          color: '#ffff',
        }}
      >
        <div className="container">
          <nav>
            <ul
              id="menu-top-bar-left"
              className="nav nav-inline pull-left animate-dropdown flip"
              style={{color: 'black'}}
            >
              <li className="menu-item animate-dropdown">
                <a
                  className="fff_fix"
                  title="Welcome to Worldwide Electronics Store"
                  href="#"
                >
                  {Object.keys(user).length === 0 ? (
                    <span style={{color: 'black'}}>Bienvenido a Aeromall </span>
                  ) : (
                    <div
                      style={{color: 'black'}}
                      onClick={() => cleanSession()}
                    >
                      Cerrar sesión
                    </div>
                  )}
                </a>
              </li>
            </ul>
          </nav>
          <nav>
            <ul
              id="menu-top-bar-right"
              className="nav nav-inline pull-right animate-dropdown flip"
            >
              {/* <li className="menu-item animate-dropdown"><a title="Store Locator" href="#" className="fff_fix"><i className="ec ec-map-pointer" />Ubicación</a></li> */}
              {/* <li className="menu-item animate-dropdown"><a title="Track Your Order" className="fff_fix"  href="#"><i className="ec ec-transport" />Revisa tu Orden</a></li> */}
              <li className="menu-item animate-dropdown">
                <a
                  title="Shop"
                  className="fff_fix"
                  href="https://www.aeromall.com.sv/aeromall-admin/public/admin/login"
                >
                  {' '}
                  <i className="ec ec-shopping-bag" style={{color: 'black'}} />
                  <span style={{color: 'black'}}>Tienda</span>
                </a>
              </li>
              <li class="menu-item animate-dropdown">
                <Link to={'/my_account'}>
                  {' '}
                  <a title="My Account" className="fff_fix" href="#">
                    {Object.keys(user).length === 0 ? (
                      <div style={{color: 'black'}}>Login</div>
                    ) : (
                      user.user.name
                    )}
                  </a>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      {useHistoryHook.pathname == '/' ? <HomeHeader /> : <HomeHeader />}
    </div>
  )
  
}

export default withRouter(Header)
